import React from 'react'

type LiveChatRatingProps = {
    liveChatRating: string,
    setRatingValue: (value: number) => void,
    closeLiveChatRating: (event: any) => void,
    liveChatComment: string,
    setLiveChatComment: React.Dispatch<React.SetStateAction<string>>
}

const LiveChatRating = ({liveChatRating, setRatingValue, closeLiveChatRating, liveChatComment, setLiveChatComment}: LiveChatRatingProps) => {

    const updateValue = (e: any) => {
        setLiveChatComment(e.target.value);
    }

    return (
        <div className="widget__overlay--livechat">
            <p className="widget__overlay--text">How was your Live Chat experience?</p>
            <div className="widget__overlay--votesection">
                <div className="widget__overlay--votesection-thumbs"><button onClick={() => setRatingValue(1)} >
                    { liveChatRating === 'good' && 
                        <img src="/images/thumbs-up-selected.png" alt="thumbs_up" />
                    }
                    
                    { liveChatRating !== 'good' && 
                        <img src="/images/thumbs-up.png" alt="thumbs_up" />
                    }
                    </button>
                    <button onClick={() => setRatingValue(-1)}>
                        { liveChatRating === 'bad' && 
                            <img src="/images/thumbs-down-selected.png" alt="thumbs_down" />
                        }
                        
                        { liveChatRating !== 'bad' && 
                            <img src="/images/thumbs-down.png" alt="thumbs_down" />
                        }
                    </button>
                </div>
                <div><textarea placeholder="Please tell us more" className="widget__overlay--votesection-comment" value={ liveChatComment } onChange={updateValue}></textarea></div>
                <div className="widget__overlay--votesection-actionbutton"><input className="widget__overlay--votesection-submit" type="button" onClick={closeLiveChatRating} value="Submit" /></div>
            </div>
        </div>
    )
}

export default LiveChatRating